import gql from "graphql-tag";
import { PrepaidBalancePartsFragmentDoc } from "icons/fragments";

export const GET_PREPAID_BALANCE = gql`
    query currentUser {
        currentUser {
            ...PrepaidBalanceParts
        }
    }
    ${PrepaidBalancePartsFragmentDoc}
`;
